import groupBy from 'lodash-es/groupBy';
import map from 'lodash-es/map';
export const getVariantTypesWithVaryingField = (types, fieldName) => {
    return types.filter((variantType) => variantType.variesBy[fieldName]);
};
export const getAttributeByType = (variant, type) => {
    return variant.attributesList.find((attribute) => attribute.type === type);
};
const getGroupLabel = (variant, variantsAttributesValues, glue = ',') => {
    return variantsAttributesValues.join(glue);
};
const getVariantTags = (variant, variantTypes) => {
    return variantTypes.map((variantType) => {
        const attribute = getAttributeByType(variant, variantType.type);
        return {
            type: variantType.type,
            name: attribute?.name,
            colorSwatch: attribute?.colorSwatch,
        };
    });
};
const getVariantAttributesValues = (variant, variantTypes) => {
    return variantTypes
        .map((variantType) => getAttributeByType(variant, variantType.type)?.name)
        .filter(Boolean);
};
const addVariantsProps = (variantGroups, variantTypes) => {
    return map(variantGroups, (variantGroup, key) => variantGroup.map((variant, index) => {
        const variantAttributesValues = getVariantAttributesValues(variant, variantTypes);
        return {
            ...variant,
            tags: getVariantTags(variant, variantTypes),
            groupId: getGroupLabel(variant, variantAttributesValues),
            groupLabel: getGroupLabel(variant, variantAttributesValues, ', '),
            isFirstOfGroup: index === 0,
            isLastOfGroup: index === variantGroups[key].length - 1,
        };
    }));
};
export const getVariantsGroups = (variants, variantTypes) => {
    const variantTypesWithVaryingImages = getVariantTypesWithVaryingField(variantTypes, 'imagery');
    const variantGroups = groupBy(variants, (variant) => {
        const variantAttributesValues = getVariantAttributesValues(variant, variantTypesWithVaryingImages);
        return getGroupLabel(variant, variantAttributesValues);
    });
    return addVariantsProps(variantGroups, variantTypesWithVaryingImages);
};
export const flattenVariantGroups = (variantGroups) => {
    return Object.keys(variantGroups).reduce((result, key) => [...result, ...variantGroups[key]], []);
};
export const updateValuesVariantQuantity = (values, variantId, quantity) => {
    return {
        ...values,
        variants: values.variants.map((variant) => {
            return {
                ...variant,
                quantity: variant.id === variantId ? quantity : variant.quantity,
            };
        }),
    };
};
export const getPreviewImageUrl = (imageIds, allImages) => {
    if (!imageIds.length)
        return undefined;
    return allImages ? allImages.find((image) => image.id === imageIds[0])?.url : undefined;
};
